import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=08e3a29d&"
import script from "./Modal.vue?vue&type=script&lang=ts&"
export * from "./Modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e3a29d')) {
      api.createRecord('08e3a29d', component.options)
    } else {
      api.reload('08e3a29d', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=08e3a29d&", function () {
      api.rerender('08e3a29d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/modal/Modal.vue"
export default component.exports